import React from 'react';

interface SubTab {
  id: string;
  label: string;
}

interface AssetSubTabsProps {
  tabs: SubTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export default function AssetSubTabs({ tabs, activeTab, onTabChange }: AssetSubTabsProps) {
  return (
    <div className="border-b border-gray-200 mb-4">
      <div className="flex space-x-4 px-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-3 py-2 text-sm font-medium transition-colors border-b-2 ${
              activeTab === tab.id
                ? 'text-blue-600 border-blue-600'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}